import { ErrorCode } from "./types";
import type { ApiError } from "./types";
export abstract class AppError extends Error {
  abstract readonly code: string;

  constructor(public override message: string) {
    super(message);
  }
}

// 502 / 503
export class NetworkError extends AppError {
  readonly code = ErrorCode.NETWORK_ERROR;

  constructor(public override message = 'Network error') {
    super(message);
  }
}

// 401
export class AuthError extends AppError {
  readonly code = ErrorCode.ANAUTHORIZED;

  constructor(public override message = 'Authentication failed') {
    super(message);
  }
}

// 403
export class ForbiddenError extends AppError {
  readonly code = ErrorCode.FORBIDDEN;

  constructor(public override message: string = 'Access denied') {
    super(message);
  }
}


// 404
export class NotFoundError extends AppError {
  readonly code = ErrorCode.NOT_FOUND;

  constructor(message = 'Resource not found' ) {
    super(message);
  }
}

// 409
export class ConflictError extends AppError {
  readonly code = ErrorCode.CONFLICT;

  constructor(
    public override message = 'Conflict',
    public details?: Record<string, unknown> | null
  ) {
    super(message);
  }
}

// 422
export class ValidationError extends AppError {
  readonly code = ErrorCode.VALIDATION_ERROR;

  constructor(
    public override message = 'Validation failed',
    public fields?: Record<string, ApiError>
  ) {
    super(message);
  }
}

// 500
export class ServerError extends AppError {
  readonly code = ErrorCode.INTERNAL_ERROR;

  constructor(public override message = 'Internal server error') {
    super(message);
  }
}

// 400
export class BusinessError extends AppError {
  readonly code = ErrorCode.BAD_REQUEST;

  constructor(public override message: string) {
    super(message);
  }
}
